<div class="hardware-info">
  <div class="image-container">
    <img [src]="imageUrl" />
  </div>
  <div class="info-container">
    <div class="manufacturer">
      {{ manufacturer }}
    </div>
    <div class="name">{{ name }}</div>
    @if (keyInformation.length > 0) {
      <div>
        @for (item of keyInformation; track $index) {
          <li>{{ item }}</li>
        }
      </div>
    }

    @if (webShopLink) {
      <a class="webshop-link" data-testid="webshop-link" target="_blank" [href]="webShopLink">Les mer i nettbutikken</a>
    }
  </div>
</div>
